import client from './client';

export const vmFindingsApi = {
  async list(params = {}) {
    const { data } = await client.get('/api/vm/findings', { params });
    return data;
  },

  async get(id) {
    const { data } = await client.get(`/api/vm/findings/${id}`);
    return data;
  },

  async overflowServices(id, { offset = 100, limit = 50 } = {}) {
    const { data } = await client.get(`/api/vm/findings/${id}/services`, {
      params: { offset, limit },
    });
    return data;
  },

  async suppress(id, reason) {
    const { data } = await client.post(`/api/vm/findings/${id}/suppress`, { reason });
    return data;
  },

  async reopen(id) {
    const { data } = await client.post(`/api/vm/findings/${id}/reopen`);
    return data;
  },

  async triage(id) {
    const { data } = await client.post(`/api/vm/findings/${id}/triage`);
    return data;
  },

  async verdictHistory(id) {
    const { data } = await client.get(`/api/vm/findings/${id}/verdicts`);
    return data;
  },
};
